import _ from "lodash";
import Vue from "vue";

function isElementIn(needle, haystack){
    if(!needle || !haystack){
        return false;
    }

    if(_.isArray(haystack)){
        return haystack.some(el => isElementIn(needle, el));
    }
    if(haystack instanceof Vue){
        return isElementIn(needle, haystack.$el);
    }

    if(needle instanceof Vue){
        return haystack === needle.$el || haystack.contains(needle.$el);
    }
    return haystack === needle || haystack.contains(needle);
}


const breakpoints = {
    xs: 0,    // Extra small devices (portrait phones, less than 576px)
    sm: 576,  // Small devices (landscape phones, 576px and up)
    md: 768,  // Medium devices (tablets, 768px and up)
    lg: 992,  // Large devices (desktops, 992px and up)
    xl: 1200  // Extra large devices (large desktops, 1200px and up)
};

// Function to check if the window width is below a specific breakpoint
function isBelowBreakpoint(breakpoint) {
    const width = window.innerWidth;
    return width < breakpoints[breakpoint];
}


export {isElementIn, isBelowBreakpoint};